import { useEffect, useState } from 'react';
import { NavLink, useNavigate, Outlet } from 'react-router-dom';
import { LayoutDashboard, Inbox, BarChart3, Stethoscope, Settings, LogOut, Menu, X } from 'lucide-react';
import { adminApi } from '../lib/api';

const LINKS = [
  { to: '/admin', icon: LayoutDashboard, label: 'Oversikt', end: true },
  { to: '/admin/henvendelser', icon: Inbox, label: 'Henvendelser' },
  { to: '/admin/trafikk', icon: BarChart3, label: 'Trafikk' },
  { to: '/admin/klinikker', icon: Stethoscope, label: 'Klinikker' },
  { to: '/admin/innstillinger', icon: Settings, label: 'Innstillinger' },
];

export default function AdminLayout() {
  const nav = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    adminApi.get('/admin/me').then((r) => setUser(r.data.username)).catch(() => nav('/admin/login')).finally(() => setLoading(false));
  }, []); // eslint-disable-line

  const logout = async () => {
    try { await adminApi.post('/admin/logout'); } catch {}
    nav('/admin/login');
  };

  if (loading) return <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center text-[#64748B]">Laster admin…</div>;

  return (
    <div className="min-h-screen bg-[#FAF8F5] lg:grid lg:grid-cols-[260px_1fr]">
      {/* Mobile top bar */}
      <div className="lg:hidden bg-[#0A1F44] text-white flex items-center justify-between px-4 py-3 sticky top-0 z-30">
        <div className="font-display text-lg font-bold">Specialists<span className="text-[#3B82F6]">.no</span></div>
        <button onClick={() => setOpen(!open)} data-testid="admin-hamburger">{open ? <X size={22}/> : <Menu size={22}/>}</button>
      </div>

      {/* Sidebar */}
      <aside className={`${open ? 'block' : 'hidden'} lg:block lg:sticky lg:top-0 lg:h-screen bg-[#0A1F44] text-white p-5 z-20`}>
        <div className="font-display text-xl font-bold mb-10 hidden lg:block">Specialists<span className="text-[#3B82F6]">.no</span></div>
        <div className="text-[10px] uppercase tracking-[0.18em] font-semibold text-white/40 mb-3">Admin</div>
        <nav className="space-y-1">
          {LINKS.map(({ to, icon: Icon, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              onClick={() => setOpen(false)}
              data-testid={`admin-nav-${label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? 'bg-white/15 text-white' : 'text-white/70 hover:bg-white/5 hover:text-white'}`}
            >
              <Icon size={16} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="absolute bottom-5 left-5 right-5 pt-4 border-t border-white/10 hidden lg:block">
          <div className="text-xs text-white/50 mb-2">Innlogget som</div>
          <div className="text-white font-semibold mb-3">{user}</div>
          <button onClick={logout} className="flex items-center gap-2 text-sm text-white/70 hover:text-white" data-testid="admin-logout">
            <LogOut size={14} /> Logg ut
          </button>
        </div>
      </aside>

      <main className="p-5 lg:p-10">
        <Outlet />
      </main>
    </div>
  );
}
